import { isEmpty, isNotDefined } from '@enterprise/core';

import { Loading } from '#loading/loading.component.tsx';
import { Portal } from '#portal/portal.component.tsx';
import { useLoadingStore } from '#store/loading/store';

import type { GlobalLoaderProps } from './types/global-loader.props';

/**
 * GlobalLoader is a component that displays a loading indicator globally when the application is in a loading state.
 * It uses the `useLoadingStore` hook to determine if loading is active, and renders the `Loading`
 * component inside a `Portal`.
 *
 * @param {GlobalLoaderProps} props - The props for the GlobalLoader component, including an optional
 * `node` for portal rendering.
 * @returns {JSX.Element | null} The loading indicator wrapped in a portal if loading is active, otherwise null.
 */
export const GlobalLoader = ({ node, ...props }: GlobalLoaderProps) => {
  const isLoading = useLoadingStore(({ isLoading }) => {
    return isLoading;
  });

  props = isNotDefined(props) || isEmpty(props) ? { size: 2, type: 'grid' } : props;

  return isLoading ? (
    <Portal node={node}>
      <Loading {...props} />
    </Portal>
  ) : null;
};
